import { Dispatch, SetStateAction } from 'react'

import { ShotlistsService } from '@/services/shotlist.service'

export const handleUploadTranslate = async (
	taskId: string,
	targetLanguage: string,
	sourceLanguage: string,
	setIsTranslating: Dispatch<SetStateAction<boolean>>,
	handlers: {
		onDone: (result: 'translation') => void
		onError: (message?: string) => void
	}
): Promise<void> => {
	if (!taskId || !targetLanguage || !sourceLanguage) return

	try {
		setIsTranslating(true)

		await ShotlistsService.translateShotlist(
			taskId,
			targetLanguage,
			sourceLanguage
		)

		handlers.onDone('translation')
	} catch (error) {
		console.log(error)
		handlers.onError(error?.message)
	} finally {
		setIsTranslating(false)
	}
}
